import React, {Component, ReactNode} from 'react';
import I18n from 'app/i18n';
import {isDesktop} from 'app/utils';

interface Props {
    enabled: boolean
    onClick: () => void
}

export default class PokerMenuButtonSound extends Component<Props> {
    functionText = (): string => {
        const {enabled} = this.props;

        if (isDesktop()) {
            return I18n.t(enabled ? 'poker.bet_sound_mute' : 'poker.bet_sound_on');
        }
        return I18n.t(enabled ? 'poker.bet_sound_mute_mobile' : 'poker.bet_sound_on_mobile');
    };

    render(): ReactNode {
        return <button className="poker-menu-container-button audio" onClick={this.props.onClick}>
            <svg className="svg-default">
                <use xlinkHref={this.props.enabled ? '#svg-volume0' : '#svg-volume70more'}/>
            </svg>
            <span className="name">{this.functionText()}</span>
        </button>;
    }
}
